// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7i-0";
export var startPickingButton = "_7i-1";